@let blogPost = blog();
@if (blogPost) {
  <section class="blog-detail content-wrapper">
    <h1 class="blog-title">{{ blogPost.title }}</h1>
    <p class="blog-meta">
      <span class="categories">
        @for (category of blogPost.categories; track $index) {
          <span class="category">{{ category }}</span>
        }
      </span>
      <span>
        <span class="author"
          >{{ blogPost.author.first_name }}
          {{ blogPost.author.last_name }}</span
        >
        <span class="date">{{
          blogPost.timestamp | date: "MMMM d, y"
        }}</span></span
      >
    </p>
    <div class="blog-content content">
      @if (blogPost.content) {
        <div [innerHTML]="blogPost.content"></div>
      }
    </div>
  </section>
}

<div class="service-divider"></div>

@if (relatedBlogs().length) {
  <div class="related-blogs content-wrapper">
    <h2 class="title">More Insights You'll Find Valuable</h2>
    <app-blog-list [blogs]="relatedBlogs()" />
  </div>
}
<div class="service-divider"></div>
